import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { AutenticacaoService } from '../../services/autenticacao.service';
import { UsuarioService } from '../../services/usuario.service';
import { Mensagem } from 'shared/entities/mensagem.entity';
import { LoginOperador } from 'shared/entities/loginoperador.entity';
import { UsuarioConta } from 'shared/entities/usuarioconta.entity';
import { NavegacaoPaginaService } from '../../services/navegacaopagina.service';
import { TrocaSenha } from 'shared/entities/trocasenha.entity';
import { TrocaSenhaToken } from 'shared/entities/trocasenhatoken.entity';
import { AlertifyService } from 'shared/services/alertify.service';
import { TranslateService } from 'shared/translate';
import { PlataformaService } from '../../services/plataforma.service';
import { ParametroService } from '../../services/parametro.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  animations: [
    trigger('openClosed', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('0.3s', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('0.1s', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})

export class LoginFormComponent implements OnInit {

  public Erros: Mensagem[] = [];
  public Item: LoginOperador = new LoginOperador();
  public SelecaoConta: boolean = true;
  public SelecaoOperador: boolean = false;
  public InformacaoSenha: boolean = false;
  public TrocaSenha: boolean = false;
  public InserirToken: boolean = false;
  public NumeroConta: string = "";
  public Usuarios: UsuarioConta[] = [];
  public TrocarOpcao: string = "false";
  public EmailUsuario: string;
  public CelularUsuario: string;
  public TipoEnvioSelecionado: string;
  public IdentificadorAtual: string;
  public TrocaDeSenhaToken: TrocaSenhaToken = new TrocaSenhaToken();
  public MostraCelular: boolean = false;
  @ViewChild('template', { static: false }) public template: TemplateRef<any>;
  modalRef: BsModalRef;
  showError = false;
  errorMessage = '';
  

  constructor(
    public _translate: TranslateService,
    readonly router: Router,
    readonly autenticacaoSrv: AutenticacaoService,
    readonly usuarioSrv: UsuarioService,
    private srvNavegacao: NavegacaoPaginaService,
    private srvPlataforma: PlataformaService,
    readonly alertify: AlertifyService,
    private srvParametro: ParametroService,
    private modalService: BsModalService
  ) {

  }

  ngOnInit() {
    if (this.autenticacaoSrv.Logado || this.autenticacaoSrv.PossuiToken()) {
      this.autenticacaoSrv.ValidarToken().subscribe(d => {
        if (d)
          this.router.navigate(['home']);

      });
    }
  }

  VerificarEnterConta(event) {
    if (event.keyCode == 13) {
      this.SelecionarConta();
    }
  }

  SelecionarConta(): void {
    this.Erros = [];
    this.autenticacaoSrv.ValidarConta(this.NumeroConta)
      .subscribe(resultado => {
        if (resultado.Sucesso) {
          if (resultado.Lista.length == 1) {
            this.Item.IdentificadorUsuario = resultado.Lista[0].Identificador;
            this.Item.Login = resultado.Lista[0].Nome;
            this.SelecaoConta = false;
            this.InformacaoSenha = true;
          }
          else {
            this.Usuarios = resultado.Lista;
            this.SelecaoConta = false;
            this.SelecaoOperador = true;
          }
        }
        else
          this.Erros = resultado.Mensagens;
      }, error => this.checkIpRateLimitError(error));
  }


  SelecionarEmailSms(identificador): boolean {
    this.MostraCelular = false;
    this.InformacaoSenha = false;
    this.Erros = [];
    this.usuarioSrv.ValidarEmailSms(identificador)
      .subscribe(resultado => {

        if (resultado.Sucesso) {
          this.IdentificadorAtual = identificador;
          this.EmailUsuario = (resultado.Lista[0].Email);

          if (resultado.Lista[0].Celular != null) {
            this.CelularUsuario = (resultado.Lista[0].Celular);
            this.MostraCelular = true;
          }

        }
        else {
          this.Erros = resultado.Mensagens;
        }
      });
    return this.TrocaSenha = true;
  }

  mudaSelecao(event: any) {
    this.TipoEnvioSelecionado = event.target.value;
  }

  EnviarResetSenha() {
    this.Erros = [];
    if (this.TipoEnvioSelecionado == undefined || this.TipoEnvioSelecionado == "") {
      return this.alertify.error('SelecionarMetodoEnvio');
    }

    this.usuarioSrv.RequisitarToken(this.IdentificadorAtual, this.TipoEnvioSelecionado)
      .subscribe(resultado => {

        if (resultado.Sucesso) {

        }
        else {
          return this.Erros = resultado.Mensagens;
        }

      });
    this.TrocaSenha = false;
    this.TipoEnvioSelecionado = "";
    this.TrocaDeSenhaToken.ConfirmacaoSenha = "";
    this.TrocaDeSenhaToken.IdentificadorUsuario = null;
    this.TrocaDeSenhaToken.NovaSenha = "";
    this.TrocaDeSenhaToken.Token = "";
    this.InserirToken = true;
  }


  AlterarSenhaToken() {
    this.Erros = [];
    this.TrocaDeSenhaToken.IdentificadorUsuario = this.Item.IdentificadorUsuario;

    var item: TrocaSenhaToken = JSON.parse(JSON.stringify(this.TrocaDeSenhaToken));
    this.srvPlataforma.RetornarChavePublica().subscribe(async chave => {

      if (item.NovaSenha)
        item.NovaSenha = await this.autenticacaoSrv.encrypt(item.NovaSenha, chave);
      if (item.ConfirmacaoSenha)
        item.ConfirmacaoSenha = await this.autenticacaoSrv.encrypt(item.ConfirmacaoSenha, chave);


      this.autenticacaoSrv.AlterarSenhaToken(item).subscribe(resultado => {
        if (resultado.Sucesso) {
          this.InserirToken = false;
          this.SelecaoConta = true;
          this.Cancelar();
          this.autenticacaoSrv.LogOut();
          //this.router.navigate(['home']);
          this.alertify.sucess(this._translate.instant('SenhaAlterada'));
        }
        else{          
          this.Erros = resultado.Mensagens;
          if (this.PossuiErroCampo())
            this.AbrirModal();
        }
      });
    });
  }

  Cancelar(): void {
    this.Item = new LoginOperador();
    this.SelecaoOperador = this.InformacaoSenha = false;
    this.Erros = [];
    this.NumeroConta = "";
    this.SelecaoConta = true;
    this.TrocaSenha = false;
    this.InserirToken = false;
  }

  SelecionarUsuario(item: UsuarioConta) {
    this.Item.IdentificadorUsuario = item.Identificador;
    this.Item.Login = item.Nome;
    this.SelecaoOperador = false;
    this.InformacaoSenha = true;
  }

  VerificarEnterLogar(event) {
    if (event.keyCode == 13) {
      this.Logar();
    }
  }

  Logar(): void {
    this.Erros = [];
    var item: LoginOperador = JSON.parse(JSON.stringify(this.Item));
    this.srvPlataforma.RetornarChavePublica().subscribe(async chave => {
      if (item.Senha)
        item.Senha = await this.autenticacaoSrv.encrypt(item.Senha, chave);
      this.autenticacaoSrv.Logar(item).subscribe(resultado => {
        if (resultado.Sucesso) {
          this.autenticacaoSrv.PreencherAcesso(resultado.ItemRegistro);
          this.srvParametro.Retornar(77).subscribe(d=>
            {
              if (d)
                this.srvNavegacao.TextoConfirmacao = d.Valor;
            })

          if (resultado.ItemRegistro.PrimeiroAcesso) {
            this.srvNavegacao.AlterarSenha(true);
          }
          else if (!resultado.ItemRegistro.IBConfirmacao && this.srvNavegacao.TextoConfirmacao) {
            this.srvNavegacao.ConfirmarInternetBanking(true);
          }
          else {
            this.router.navigate(['home']);
          }
        }
        else {
          this.Erros = resultado.Mensagens;
          this.checkBloqueioSenha(resultado.Mensagens);
        }
      }, error => {
        this.checkIpRateLimitError(error);
      });
    }, error => this.checkIpRateLimitError(error));
  }

  PossuiErroCampo(): boolean {
    return this.Erros && this.Erros.some(d => !d.Campo || d.Campo.length == 0);
  }
  private AbrirModal(): void {
    
      this.modalRef = this.modalService.show(
          this.template, {
              backdrop: 'static',
          keyboard: false
          });
  }
  onConfirm(): void {
      if (this.modalRef)
          this.modalRef.hide();
  }

  checkIpRateLimitError(erro: HttpErrorResponse) {
    const rateLimitError = JSON.stringify(erro).includes('429');
    if (rateLimitError){    
      this.errorMessage = this._translate.instant('ErroMultiplosAcessos');
      this.showError = true;
    }
  }

  checkBloqueioSenha(erro: Mensagem[]) {
    const rateLimitError = erro.find(mensagem => mensagem.Texto.toLowerCase().includes('bloqueio tentativas inválidas'));
    if (rateLimitError){    
      this.errorMessage = this._translate.instant('BloqueioSenhaMsg');
      this.showError = true;
    }
  }

  closeErrorPopup(): void {
    this.showError = false;
    this.errorMessage = '';
  }
  
}
